import React, { useState } from 'react';
import { useGetUser } from 'src/hooks/useGetUser';
import { useEditMetric } from 'src/data/impact/mutation/impact-mutation';
import SubValueRowItem from './SubValueRowItem';

const ValuesRow = ({ id, data }: { data: any; id: string }) => {
  const user = useGetUser();
  const editMetric = useEditMetric();

  const [editingKey, setEditingKey] = useState<number | undefined>();
  const [editedValues, setEditedValues] = useState<{ [key: number]: string }>({});

  const handleUpdateValue = (key: number) => {
    const index = data.values.findIndex(
      (item: { key: number; value: string }) => item.key == key
    );

    if (index !== -1) {
      const newValues = [...data.values];
      newValues[index].value = editedValues[key];

      editMetric.mutate(
        {
          values: newValues,
          id,
        },
        {
          onSuccess: () => {
            setEditingKey(undefined);
          },
          onError: () => {
            // Error handling can be added here
          },
        }
      );
    }
  };

  return (
    <>
      {data.values.map((v: any) => (
        <SubValueRowItem
          key={v.key}
          data={data}
          v={v}
          editingKey={editingKey}
          setEditingKey={setEditingKey}
          editedValues={editedValues}
          setEditedValues={setEditedValues}
          id={id}
        />
      ))}
    </>
  );
};

export default ValuesRow;